import { IAppState } from 'shared/common/state';

export const animationDelayMsSelector = (state: IAppState): number => {
  return state.consultantCianChat.animationDelayMs;
};
